import { render } from "./TokenBadge.vue?vue&type=template&id=4f75ff05&scoped=true"
import script from "./TokenBadge.vue?vue&type=script&lang=js"
export * from "./TokenBadge.vue?vue&type=script&lang=js"

import "./TokenBadge.vue?vue&type=style&index=0&id=4f75ff05&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f75ff05"]])

export default __exports__